module.exports = __webpack_public_path__ + "static/media/galerija_2015 (1).66f9460d.jpg";